export default function NoNotifications() {
  return (
    <div className="bg-black min-h-screen flex justify-center items-center text-white font-sans p-0 m-0 box-border">
      <div className="text-center">
        <h2 className="text-[22px] font-bold mb-2">No Notifications Yet</h2>
        <p className="text-sm text-gray-400">When something arrives, it will show up here.</p>
        <p className="text-sm text-gray-400">So, kindly go back..</p>
      </div>
    </div>
  );
}
